    window.addEventListener('scroll', function() {
        const elementToHide = document.getElementById('shopify-chat');
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = document.documentElement.scrollTop;
        const clientHeight = document.documentElement.clientHeight;

        const isAtBottom = (scrollTop + clientHeight >= scrollHeight - 150);

        if (isAtBottom) {
            elementToHide.classList.add('visually-hidden');
        } else {
            elementToHide.classList.remove('visually-hidden');
        }
    });